import React, { Fragment } from "react";
import { CalculatedText } from "../calculated-text/CalculatedText";
import componentStateMapper from "../componentsStateMapper";

export class CalculatedTextHidden extends CalculatedText {
  render = () => <Fragment />;
}

export default componentStateMapper(CalculatedTextHidden);
